import * as confirmerPaiementSouscriptionFormNames from "./confimerPaiementSouscriptionFormNames";

export const confirmerPaiementSouscriptionInitialValues = {
  [confirmerPaiementSouscriptionFormNames.CONFIRMER_PAIEMENT_MOYEN_PAIEMENT_FORM_NAME]:
    "",
  [confirmerPaiementSouscriptionFormNames.FILE_FORM_NAME]: "",
};
